import React, {useState, useEffect} from 'react'
import CommonHeader from '../../sub-components/CommonHeader'
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Slide from '@mui/material/Slide';
import OnDelivery from '../OnDelivery';
import OnPickUp from '../OnPickUp';
import { useHistory } from 'react-router-dom';
import { auth } from '../../firebase';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }
function Checkout({user}) {
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const theme = useTheme();
    const history = useHistory()
    const [value, setValue] = React.useState(0);
    const [show1, setShow1] = useState(false);
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    
      const handleChangeIndex = (index) => {
        setValue(index);
      }; 

      if(!auth?.currentUser?.uid){
        history.push("/")
      }
  return (
    <div>
        <CommonHeader/>
        <AppBar sx={{ position: 'absolute', backgroundColor:'#f5461b',zIndex:1,marginTop:10 }}
>        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          style={{backgroundColor:'#f5461b'}}          
        >
          <Tab label="On Dellivery" {...a11yProps(0)} />
          <Tab label="On PickUp" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
        <Box sx={{ bgcolor: 'background.paper'}}>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel style={{ marginTop:80 }} value={value} index={0} dir={theme.direction}>
        <OnDelivery userId={user} />
        </TabPanel>
        <TabPanel style={{ marginTop:80 }} value={value} index={1} dir={theme.direction}>
        <OnPickUp userId={user}/>
        </TabPanel>

      </SwipeableViews>
    </Box>
    </div>
  )
}

export default Checkout